import { MenuTabsWrap } from 'pages/menu/components/menu-tabs';
import { MenuRecentItemsPage } from 'pages/menu/recent-items-page';
import { useStoreRequired } from 'state/store/hooks/use-store-required';

export default function MenuScreen() {
  useStoreRequired();

  return (
    <MenuTabsWrap>
      <MenuRecentItemsPage />
    </MenuTabsWrap>
  );
}
